import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import NutritionFolateCombined from "./index";

const NutritionFolateWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={NutritionFolateCombined}
    keyControlsId="nutrition-folate-key"
    {...props}
  />
);

export default NutritionFolateWithToggleKey;
